export default __webpack_public_path__ + "static/tanecni-kurzy-6-a12049846b440ae26f46ca8ab5c824f9.jpg";